export const filterUsersBySearch = (users, searchTerm = "") => {
  const term = searchTerm.trim().toLowerCase();

  if (!term) return users;

  return users.filter((user) =>
    [user.sub, user.name, user.email].some((field) =>
      String(field || "")
        .toLowerCase()
        .includes(term)
    )
  );
};
